import type { CSSProperties } from 'react';
import classNames from 'classnames';
import { isArray } from '@dimjs/lang';
import './style.less';

export type CodeRenderProps = {
  code?: string | string[];
  className?: string;
  style?: CSSProperties;
  /** 是否换行，默认值：true */
  wrap?: boolean;
  size?: 'small' | 'default';
};

/**
 * 代码、json格式化渲染
 * ```
 * 1. wrap 是否换行，默认值：true
 * 例如：
 * // json数据渲染
 * <CodeWrapper code={JSON.stringify(data, null, 2)}/>
 * 
 * // 代码渲染
 * <CodeWrapper code={`def results=[];
def datas=表单字段.dataList;
for index,data in datas do
    def item = [
        'a':data.DomainName,
        'b':data.Owner,
        'userName': 流程参数.发起人账号
    ];
    results = results+item;
end
return results;
` 
}/>
 *
 * ```
 *
 */
export const CodeRender = (props: CodeRenderProps) => {
  const { code, className, style, wrap, size } = props;
  const codeList = (isArray(code) ? code : [code]) as any[];
  const codeRenderClassName = classNames('code-render', className, {
    'code-render-small': size === 'small',
  });

  if (!props.code) return null;

  const wrapFt = wrap === undefined ? true : wrap;

  return (
    <pre className={codeRenderClassName} style={style}>
      <code
        style={{ whiteSpace: wrapFt ? 'pre' : 'nowrap' }}
      >{`${codeList.join('\n')}`}</code>
    </pre>
  );
};
